import React from "react";
import { Box, HStack } from "@chakra-ui/react";
import { theme } from "src/styles/theme";
import { keyframes } from "@emotion/react";

const TypingIndicator: React.FC = () => {

  // Animação dos pontinhos
  const bounce = keyframes`
    0%, 80%, 100% {
      transform: translateY(0);
    }
    40% {
      transform: translateY(-8px);
    }
  `;

  return (
    <HStack spacing={1} align="center" justify="center" py={2}>
      {[0, 0.2, 0.4].map((delay, i) => (
        <Box
          key={i}
          w="8px"
          h="8px"
          bg={theme.primary}
          borderRadius="50%"
          animation={`${bounce} 1.4s infinite ease-in-out`}
          display="inline-block"
          sx={{ animationDelay: `${delay}s` }}
        />
      ))}
    </HStack>
  );
};

export default TypingIndicator;
